/* HOMS mobile nav drawer
 * Vanilla, no framework. Behaviour:
 *  - hamburger toggles drawer (slide-in from right)
 *  - backdrop click + ESC + close-button all dismiss
 *  - focus trapped within drawer while open
 *  - focus returns to the trigger on close
 *  - prefers-reduced-motion: no animation, just visibility flip (CSS-driven via [data-reduced-motion])
 */
(function () {
  function init(root) {
    const trigger = root.querySelector('[data-homs-nav-trigger]');
    const drawer  = root.querySelector('[data-homs-nav-drawer]');
    const backdrop = root.querySelector('[data-homs-nav-backdrop]');
    const closeBtn = root.querySelector('[data-homs-nav-close]');
    if (!trigger || !drawer || !backdrop || !closeBtn) return;

    const focusableSel = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input:not([disabled])';
    let lastFocused = null;

    function getFocusable() {
      return Array.from(drawer.querySelectorAll(focusableSel)).filter((el) => {
        return el.offsetParent !== null || el === document.activeElement;
      });
    }

    function open() {
      lastFocused = document.activeElement;
      root.setAttribute('data-homs-nav-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');
      drawer.removeAttribute('hidden');
      backdrop.removeAttribute('hidden');
      document.documentElement.style.overflow = 'hidden';
      // move focus to close button after the next frame so the element is visible
      requestAnimationFrame(() => closeBtn.focus());
      document.addEventListener('keydown', onKey);
    }

    function close() {
      root.removeAttribute('data-homs-nav-open');
      trigger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('hidden', '');
      backdrop.setAttribute('hidden', '');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      } else {
        trigger.focus();
      }
    }

    function onKey(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key === 'Tab') {
        const focusable = getFocusable();
        if (focusable.length === 0) {
          e.preventDefault();
          return;
        }
        const first = focusable[0];
        const last  = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    trigger.addEventListener('click', () => {
      if (root.getAttribute('data-homs-nav-open') === 'true') close();
      else open();
    });
    closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);

    // If the viewport widens past the mobile breakpoint while the drawer is open, dismiss it.
    const mq = window.matchMedia('(min-width: 721px)');
    const onMqChange = (evt) => {
      if (evt.matches && root.getAttribute('data-homs-nav-open') === 'true') close();
    };
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', onMqChange);
    else if (typeof mq.addListener === 'function') mq.addListener(onMqChange);
  }

  function boot() {
    document.querySelectorAll('[data-homs-nav-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
